/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateAccessKeyResponse
 */
export interface CreateAccessKeyResponse {
    /**
     * The newly created bearer token (API access key)
     * @type {string}
     * @memberof CreateAccessKeyResponse
     */
    apiAccessKey: string;
}

/**
 * Check if a given object implements the CreateAccessKeyResponse interface.
 */
export function instanceOfCreateAccessKeyResponse(value: object): value is CreateAccessKeyResponse {
    let isInstance = true;
    isInstance = isInstance && "apiAccessKey" in value && value["apiAccessKey"] !== undefined;

    return isInstance;
}

export function CreateAccessKeyResponseFromJSON(json: any): CreateAccessKeyResponse {
    return CreateAccessKeyResponseFromJSONTyped(json, false);
}

export function CreateAccessKeyResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateAccessKeyResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'apiAccessKey': json['api_access_key'],
    };
}

export function CreateAccessKeyResponseToJSON(value?: CreateAccessKeyResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'api_access_key': value.apiAccessKey,
    };
}

